import styled from 'styled-components';
import media from './MediaQueries';

const StyledProduct = styled.li`
  cursor: pointer;
  position: relative;
  width: 300px;
  height: 200px;
  background-color: white;
  border-radius: 6px;
  margin-right: 20px;
  box-shadow: 0 0 18px 0 rgba(0, 0, 0, 0.2);
  line-height: 1.4;
  overflow: hidden;
  ${media.phone`
    width: 250px;
    height: 120px;
  `}
  .color {
    position: absolute;
    bottom: 20px;
    left: 20px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    border: 2px solid #f3f3f3;
  }
  .label {
    position: absolute;
    left: 20px;
    top: 20px;
    ${media.phone`
      font-size: 14px;
      text-align: right;
      left: initial;
      right: 20px;
      top: 10px;
    `}
  }
  .ratingSection {
    position: absolute;
    right: 0;
    padding: 20px 20px 0px 0px;
    font-size: 13px;
    text-align: right;
    ${media.phone`
      display: none;
    `}
  }
  .reviewCountValue {
    font-size: 10px;
    color: gray;
  }
  .tryon {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
    background: transparent;
    width: 44px;
    height: 25px;
    border: 2px solid #0091ff;
    border-radius: 4px;
    color: #0091ff;
    font-style: italic;
    font-size: 10px;
    font-weight: 700;
    ${media.phone`
      bottom: 15px;
      top: auto;
      z-index: 2;
    `}
  }
  .active {
    color: white;
    background: #0091ff;
  }
  .infoboxBottom {
    top: auto !important;
    justify-content: space-around;
    width: 100%;
    left: 10px !important;
    button {
      cursor: pointer;
      background: #bbb;
      border: 2px solid #bbb;
      padding: 4px;
      border-radius: 4px;
      color: white;
      font-style: italic;
      font-size: 10px;
      font-weight: 700;
      width: 40%;
    }
    button:disabled {
      background: #eee;
      border: 2px solid #eee;
    }
  }
  .infoboxSmall {
    height: 90px !important;
    img {
      height: 90px !important;
    }
    .name {
      font-size: 13px !important;
    }
    .desc {
      font-size: 11px !important;
    }
  }
  .infobox {
    position: absolute;
    left: 20px;
    top: 60px;
    bottom: 20px;
    padding-right: 20px;
    display: flex;
    ${media.phone`
      left: 10px;
      top: 0;
    `}
    img {
      pointer-events: none;
      height: 120px;
      min-width: 85px;
      object-fit: contain;
      ${media.phone`
        width: 85px;
      `}
    }
    .details {
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-size: 14px;
        font-weight: 500;
        color: #4a4a4a;
        ${media.phone`
          font-size:12px;
          margin-top: 40px;
        `}
      }
      .desc {
        color: #9b9b9b;
        font-size: 12px;
        font-weight: 700;
        ${media.phone`
          display: none;
        `}
      }
      .price {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
`;

export default StyledProduct;



// WEBPACK FOOTER //
// ./src/components/instore/ProductCard.style.js